"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JapanTermsAndConditionsList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _BulletListItem = require("../../../base-components/BulletListItem/BulletListItem");
var _Sanitizer = require("../../../base-components/Sanitizer/Sanitizer");
var _Icon = require("../../../base-components/Icon/Icon");
var _svgFetcher = _interopRequireDefault(require("../../../utils/svgFetcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var JapanTermsAndConditionsList = exports.JapanTermsAndConditionsList = function JapanTermsAndConditionsList(_ref) {
  var BulletListSvg = _ref.BulletListSvg,
    content = _ref.content,
    qeId = _ref.qeId,
    styles = _ref.styles;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.descriptions,
    "data-qe-id": qeId
  }, content.map(function (contentItem, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.description,
      key: "description-".concat(index + 1)
    }, /*#__PURE__*/_react["default"].createElement(_BulletListItem.BulletListItem, {
      image: /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        Svg: BulletListSvg
      })
    }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      className: styles.descriptionHeader,
      Component: "div",
      safelySetInnerHTML: contentItem.header
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list"
    }, contentItem.desc.map(function (list, listIndex) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "list-".concat(listIndex + 1)
      }, list.content.map(function (listItem, listItemIndex) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: "list-item-".concat(listItemIndex + 1),
          className: (0, _classnames2["default"])('list-item', _defineProperty({}, listItem.bullet, listItem.bullet))
        }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
          className: "list-item-text",
          Component: "span",
          safelySetInnerHTML: listItem.text
        }));
      }));
    }))));
  }));
};
JapanTermsAndConditionsList.propTypes = {
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    header: _propTypes["default"].string,
    desc: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      type: _propTypes["default"].string,
      content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        type: _propTypes["default"].string,
        text: _propTypes["default"].string
      }))
    }))
  })),
  BulletListSvg: _propTypes["default"].element,
  qeId: _propTypes["default"].string,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string)
};
JapanTermsAndConditionsList.defaultProps = {
  BulletListSvg: (0, _svgFetcher["default"])('checkmark', 'us-commercial'),
  content: [],
  qeId: undefined,
  styles: {}
};